<template>
	<v-dialog
		v-model="visible"
		fullscreen
		hide-overlay
	>
		<div class="progress-wrap" style="height: 80%">
			<v-progress-circular
				:size="120"
				:width="10"
				:color="color"
				indeterminate
			>
				{{ note }}
			</v-progress-circular>
		</div>
	</v-dialog>
</template>
<script>
export default {
	name: 'DialogProgress',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ""
		},
		note: {
			type: String,
			default: ""
		},
	}
}
</script>
<style lang="scss" scoped>
.progress-wrap {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
</style>